import React from 'react';

import AdminLayout from './admin/AdminLayout';
import AppRoutes from './admin/routes';  // Las rutas de tu aplicación
import { ThemeProvider } from "@material-tailwind/react";
const App = () => {
  return (
      
      <div>
        
        <ThemeProvider>
        
        <AppRoutes /> {/* Las rutas de tu aplicación */}
        

        </ThemeProvider>
      </div>
    
  );
};

export default App;
